import React, { useEffect, useState } from 'react';
import axios from 'axios';
import MetaTags from 'react-meta-tags';
import { useNavigate, Link } from "react-router-dom";
import '../styles/loginpage.css';            // reuse the same styling as login & signup
import Logo from '../images/new_logo.png';
import { Form, Input, Button, Typography } from 'antd';
import { MailOutlined } from '@ant-design/icons';

const ForgetPasswordPage = () => {
  const [nomailError, setNoEmailError] = useState(false);
  const [notActiveError, setNotActiveError] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);

  const navigate = useNavigate();
  const itemStr = localStorage.getItem('isLogin');
  const item = itemStr ? JSON.parse(itemStr) : null;
  const now = new Date();

  const { Title } = Typography;
  const [form] = Form.useForm();

  useEffect(() => {
    try {
      if (itemStr && item && item.expiry > now.getTime()) {
        navigate('/');
      }
    } catch (e) {
      // ignore parse/other errors
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function onFinish(data) {
    setNoEmailError(false);
    setSuccessMsg(false);
    setNotActiveError(false);

    try {
      const json = JSON.stringify({ email: data.email });
      const headers = { 'Content-Type': 'application/json' };

      const response = await axios.post(
        'https://epolylearning.com/Services/polyquiz.svc/ForgotPassword',
        json,
        { headers }
      );

      const userData = response.data;
      const fp = userData?.ForgotPasswordResult;

      if (fp?.FirstName === "No Such Email.") {
        setNoEmailError(true);
      } else if (fp?.Email !== undefined && fp?.IsActivated === true) {
        setSuccessMsg(true);
        form.resetFields();
      } else if (fp?.Email !== undefined && fp?.IsActivated === false) {
        setNotActiveError(true);
      } else {
        // fallback: show no-mail error
        setNoEmailError(true);
      }
    } catch (error) {
      console.error(error);
      setNoEmailError(true);
    }
  }

  return (
    <>
      <MetaTags>
        <title>Reset Your Password - PolyQuiz</title>
        <meta id="meta-description" name="description" />
      </MetaTags>


      <div className="login-page-root">
        <div className="login-card">

          <div className="login-header">
            <img className="login-logo" src={Logo} alt="Logo" />
            <div className="login-title-wrap">
              <h1 className="login-title">Forgot Your Password?</h1>
              <div className="login-subtitle">Reset your password to get access to your account. 
                You’ll receive an email with instructions to update your password and sign in again.</div>
            </div>
          </div>

          <div className="login-form-wrap">
            <Form
              form={form}
              name="forgot_password"
              className="login-form"
              initialValues={{ remember: true }}
              onFinish={onFinish}
              layout="vertical"
            >
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { type: 'email', message: 'The input is not valid E-mail!' },
                  { required: true, message: 'Please input your E-mail!' }
                ]}
              >
                <Input
                  prefix={<MailOutlined />}
                  placeholder="your.email@example.com"
                  className="styled-input"
                />
              </Form.Item>

              <Form.Item className="login-submit">
                <Button type="primary" htmlType="submit" className="login-btn">
                  Send Reset Link
                </Button>
              </Form.Item>
            </Form>

            {notActiveError && (
              <div className="login-message error">
                Account associated with this Email is not verified. Please check your mail for the verification link.
              </div>
            )}

            {nomailError && (
              <div className="login-message error">
                There is no account associated with this Email. Please <Link to="/register">Sign Up</Link> to get started.
              </div>
            )}

            {successMsg && (
              <div className="login-message success">
                Mail sent successfully. Please check your mail for password reset link.
              </div>
            )}

            <div className="login-footer-links" style={{ marginTop: 14 }}>
              <div className="signup-line">
                Don't have an account? <Link to="/register" className="signup-link">Sign Up</Link>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default ForgetPasswordPage;
